import { useState } from "react";
import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import MobFinalScreen from "./pages/mobile/MobFinalScreen";
import MobForgotPassword from "./pages/mobile/MobForgotPassword";
import MobGoldenAwards from "./pages/mobile/MobGoldenAwards";
import MobHome from "./pages/mobile/MobHome";
import MobLeaderboard from "./pages/mobile/MobLeaderboard";
import MobLogin from "./pages/mobile/MobLogin";
import MobPlaySpots from "./pages/mobile/MobPlaySpots";
import MobPrizes from "./pages/mobile/MobPrizes";
import MobProfile from "./pages/mobile/MobProfile";
import MobRegister from "./pages/mobile/MobRegister";
import MobSettings from "./pages/mobile/MobSettings";
import MobSupport from "./pages/mobile/MobSupport";
import MobTermsConditions from "./pages/mobile/MobTermsConditions";
import MobWinnerProfile from "./pages/mobile/MobWinnerProfile";
import UnderMaintain from "./pages/UnderMaintain";
import ProtectedRoutes from "./routes/ProtectedRoutes";
import WebView from "./webView/WebView";
import { useMaintenanceStatus } from "./hooks/useMaintenanceStatus";
import { useInitializeSettings } from "./hooks/useSettings";
import useUpdateWeekDays from "./hooks/useUpdateWeekDays";
import AuthTabs from "./mobileView/auth/authTabs";
import MobileWinners from "./pages/mobile/MobWinner";

function App() {
  const [windowDimension, setWindowDimension] = useState(null);
  const { underMaintenance } = useMaintenanceStatus();
  useUpdateWeekDays();
  const {isTournamentOver,settings}= useInitializeSettings();

  useEffect(() => {
    setWindowDimension(window.innerWidth);
  }, []);

  useEffect(() => {
    function handleResize() {
      setWindowDimension(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowDimension <= 640;

  if(!settings) return null;


  if (underMaintenance) {
    return (
      <Router>
        <Routes>
          <Route path="/under-maintenance" element={<UnderMaintain />} />
          <Route
            path="*"
            element={<Navigate to="/under-maintenance" replace />}
          />
        </Routes>
      </Router>
    );
  }

  return (
    <Router>
      <Routes>
        {isMobile ? (
          <>
            <Route
              path="/mobile-forgot-password"
              element={<MobForgotPassword />}
            />
            <Route path="/mobile-login" element={<AuthTabs />} />
            <Route path="/mobile-register" element={<AuthTabs />} />
            <Route path="/mobile-leaderboard" element={<MobLeaderboard />} />
            <Route
              path="/mobile-terms-conditions"
              element={<MobTermsConditions />}
            />
            <Route
              path="/mobile-winners"
              element={<MobileWinners />}
            />
            
            <Route path="/playspots" element={<MobPlaySpots />} />
            {/* <Route path="/mobile-prizes" element={<MobPrizes />} /> */}
            <Route path="/bonus-questions" element={<MobGoldenAwards />} />
            <Route element={<ProtectedRoutes />}>
              <Route path="/mobile-support" element={<MobSupport />} />
              <Route path="/mobile-settings" element={<MobSettings />} />
              <Route
                path="/mobile-user-profile"
                element={<MobWinnerProfile />}
              />
              <Route path="/mobile-profile" element={<MobProfile />} />
            </Route>
            <Route exact path="/home" element={<MobHome />} />
            {/* <Route
              path="/"
              element={isTournamentOver ? <MobFinalScreen /> : <MobHome />}
            /> */}
            <Route
  path="/"
  element={<MobileWinners />}
/>
            <Route path="*" element={<Navigate to="/" replace />} />
          </>
        ) : (
          <>
            {/* <Route
              path="/mobile-forgot-password"
              element={<MobForgotPassword />}
            />
            <Route path="/mobile-login" element={<MobLogin />} />
            <Route path="/mobile-register" element={<MobRegister />} />
            <Route path="/mobile-leaderboard" element={<MobLeaderboard />} />
            <Route element={<ProtectedRoutes />}>
              <Route path="/mobile-profile" element={<MobProfile />} />
              <Route path="/mobile-prizes" element={<MobPrizes />} />
              <Route
                path="/mobile-terms-conditions"
                element={<MobTermsConditions />}
              />
              <Route path="/mobile-support" element={<MobSupport />} />
              <Route path="/mobile-settings" element={<MobSettings />} />
            </Route> */}
            <Route exact path="/" element={<WebView />} />
            <Route path="*" element={<Navigate to="/" replace />} />
            {/* <Route exact path="/prediction" element={<Home />} /> */}
          </>
        )}
      </Routes>
    </Router>
  );
}

export default App;